<template>
<v-dialog v-model="isActive" scrollable persistent>
  <v-card v-if="isActive">
    <div v-if="client" class="card-header-tabs">
      <div @click="changeTab('select')" v-bind:class="[currentTab === 'select' ? 'selected' : '', 'header-tab']" >
        Selecionar
      </div>
      <div @click="changeTab('register')" v-bind:class="[currentTab === 'register' ? 'selected' : '', 'header-tab']">
        Cadastrar
      </div>
    </div>
    <v-divider></v-divider>
    <div v-if="currentTab === 'select'">
      <v-card-title class="px-4 pb-4">
        Selecionar Veículo
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-if="isLoading" style="overflow: hidden; height: 90px">
          <v-progress-circular class="mt-3" color="#777" indeterminate></v-progress-circular>
        </div>
        <div v-if="!isLoading && list.length === 0" style="overflow: hidden; height: 90px; text-align: center;">
          <v-icon class="mt-5 mb-1" size="40">
            mdi-alert
          </v-icon><br />
          <span>Cliente sem veículos cadastrados</span>
        </div>
        <v-radio-group v-if="!isLoading && list.length > 0" v-model="selected" column hide-details class="mt-0">
          <v-radio v-for="vehicle in list" :key="vehicle.id" :label="vehicle.description + ' (' + vehicle.vehicle_plate + ')'" :value="vehicle.id"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="close()">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="close()" :disabled="!selected">
          Selecionar
        </v-btn>
      </v-card-actions>
    </div>
    <div v-if="currentTab === 'register'">
      <v-card-title class="px-4">
        Cadastrar Veículo
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text >
        <div class="pt-1" style="overflow: hidden">
          <v-text-field
            v-mask="'XXX-XXXX'"
            :disabled="isLoading"
            v-model="register_vehicle.vehicle_plate"
            label="*Placa"
            class="pb-4 pr-1"
            color="#777"
            hide-details
            dense
            outlined
            style="width: 35%; float: left;"
          ></v-text-field>
          <v-select
            :disabled="isLoading"
            :items="vehicle_brands"
            v-model="register_vehicle.vehicle_brand_id"
            item-text="description"
            item-value="id"
            label="*Marca"
            class="pb-4 pl-1"
            color="#777"
            outlined
            hide-details
            dense
            style="width: 65%; float: left;"
          ></v-select>
        </div>
        <div class="pt-1" style="overflow: hidden">
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.description"
            color="#777"
            label="*Descrição/Modelo"
            class="pb-4 pr-1"
            hide-details
            dense
            outlined
            style="width: 65%; float: left;"
          ></v-text-field>
          <v-select
            :items="vehicle_color"
            v-model="register_vehicle.color"
            :disabled="isLoading"
            label="*Cor"
            class="pb-4 pl-1"
            color="#777"
            outlined
            hide-details
            dense
            style="width: 35%; float: left;"
          ></v-select>
        </div>
        <div class="pt-1" style="overflow: hidden">
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.year"
            v-mask="['####']"
            color="#777"
            label="*Ano"
            class="pb-4 pr-1"
            hide-details
            dense
            outlined
            style="width: 50%; float: left;"
          ></v-text-field>
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.year_model"
            v-mask="['####']"
            color="#777"
            label="*Ano Modelo"
            class="pl-1"
            hide-details
            dense
            outlined
            style="width: 50%; float: left;"
          ></v-text-field>
        </div>
        <div style="overflow: hidden">
          <v-select
            :items="vehicle_fuel"
            v-model="register_vehicle.fuel"
            :disabled="isLoading"
            label="*Combustível"
            class="pb-4 pt-1"
            color="#777"
            outlined
            hide-details
            dense
          ></v-select>
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.chassi"
            color="#777"
            label="Chassi"
            class="pb-4 pt-1"
            hide-details
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="pt-1" style="overflow: hidden">
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.engine_cc"
            v-mask="['####']"
            color="#777"
            label="Cilindradas"
            class="pb-4 pr-1"
            hide-details
            dense
            outlined
            style="width: 50%; float: left;"
          ></v-text-field>
          <v-text-field
            :disabled="isLoading"
            v-model="register_vehicle.engine_cv"
            v-mask="['####']"
            color="#777"
            label="Cavalos"
            class="pl-1"
            hide-details
            dense
            outlined
            style="width: 50%; float: left;"
          ></v-text-field>
        </div>
        <div class="pt-1 px-2" style="overflow: hidden">
          <v-switch
            :disabled="isLoading"
            v-model="register_vehicle.imported"
            label="Importado"
            class="mt-0 mb-1"
            hide-details
            style="width: 50%; float: left;"
          ></v-switch>
          <v-switch
            :disabled="isLoading"
            v-model="register_vehicle.blindado"
            label="Blindado"
            class="mt-0 mb-1"
            hide-details
            style="width: 50%; float: left;"
          ></v-switch>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="close()" :disabled="isLoading">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="registerVehicle()" color="primary" depressed :disabled="isLoading || isSaveDisabled">
          Cadastrar
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'ModalManageVehicle',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      currentTab: 'select',
      vehicle_fuel: [
        'Álcool / Gasolina',
        'Gasolina',
        'Álcool',
        'Diesel',
        'Gasolina/Elétrico',
        'Elétrico'
      ],
      vehicle_color: [
        'Prata',
        'Cinza',
        'Branca',
        'Preta',
        'Vermelha',
        'Azul',
        'Bege',
        'Verde',
        'Amarela',
        'Marrom',
        'Roxa'
      ],
      vehicle_brands: null,
      register_vehicle: {
        vehicle_plate: null,
        vehicle_brand_id: null,
        description: null,
        color: null,
        year: null,
        year_model: null,
        fuel: null,
        chassi: null,
        engine_cc: null,
        engine_cv: null,
        imported: null,
        blindado: null,
      },
      isLoading: false,
      list: [],
      selected: null,
    };
  },
  computed: {
    isSaveDisabled() {
      return !this.register_vehicle.vehicle_plate
          || !this.register_vehicle.vehicle_brand_id
          || !this.register_vehicle.description
          || !this.register_vehicle.color
          || !this.register_vehicle.year
          || !this.register_vehicle.year_model
          || !this.register_vehicle.fuel;
    }
  },
  mounted() {
    if (this.client) {
      this.getVehicleList();
    }
    this.getVehicleBrands();
  },
  watch: {
    client() {
      this.getVehicleList();
    }
  },
  methods: {
    close(data) {
      if (data) {
        this.$emit('close', data);
      } else {
        const selected = this.list.find((vehicle) => vehicle.id === this.selected);
        this.$emit('close', selected || null);
      }
    },
    getVehicleList() {
      const self = this;

      self.isLoading = true;

      self.$http.get('/vehicles', {
        params: {
          id_client: self.client?.id,
          size: 10,
        },
      }).then((response) => {
        self.list = response.data.rows;
        self.isLoading = false;
      }).catch(() => {
        self.isLoading = false;
      });
    },
    getVehicleBrands() {
      const self = this;

      self.isLoading = true;

      self.$http.get('/vehicle/brands').then((response) => {
        self.vehicle_brands = response.data;
        self.isLoading = false;
      }).catch(() => {
        self.isLoading = false;
      });
    },
    changeTab(tab) {
      if (!this.isLoading) {
        this.currentTab = tab;

        this.register_vehicle = {
          vehicle_plate: null,
          vehicle_brand_id: null,
          description: null,
          color: null,
          year: null,
          year_model: null,
          fuel: null,
          chassi: null,
          engine_cc: null,
          engine_cv: null,
          imported: null,
          blindado: null,
        }
      }
    },
    registerVehicle() {
      const self = this;

      self.isLoading = true;

      try {
        self.$http.post(`/vehicle/create`, {...self.register_vehicle, client_id: self.client?.id}).then((r) => {
          self.close(r.data.created);
          this.currentTab = 'select';

          this.getVehicleList();
        });
      } catch (e) {
        console.log(e);
        self.isLoading = false;
      } finally {
        self.isLoading = false;
      }
    }
  },
};
</script>
